import { AxiosResponse } from 'axios';

export function mapToData(response: AxiosResponse) {
  return response.data;
}
